import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import IntegrationBreadcrumb from 'components/Integration/components/IntegrationBreadcrumb'
import { fetchEloquaFields, fetchEloquaMappings, patchEloquaMappings } from 'app/modules/eloqua/actions'
import { fetchAttributes } from 'app/modules/endUser/attribute/actions'
import { filteredProperties } from 'app/modules/endUser/attribute/selectors'
import { getFields, getMappings, didPatchErr, isPatchLoading } from 'app/modules/eloqua/selectors'
import AttributeMapper from '../../components/AttributeMapper'
import { EloquaMapping } from 'app/modules/eloqua/models'
import { Input } from '@driftt/tide-core-legacy'
import withNotifications from 'components/shared/notifications'
import { getEloquaConfig, patchEloquaConfig } from 'app/modules/integrations/api'

import './style.styl'

const HELP_DOC_URL = "https://gethelp.drift.com/hc/en-us/articles/360019666973-How-to-Connect-Drift-and-Eloqua"
const integrationName = "Eloqua"
const getSuccessMessage = (integrationName) => `You successfully updated your ${integrationName} App!`

class EloquaAttributeMapping extends Component {
  constructor(props){
    super(props)
    this.state = {
      mappings: props.mappings,
      specialFields: [
        { "label" : "Lead Owner", "type" : "STRING", value: "_integrations_lead_owner" }
      ]
    }
  }

  componentWillReceiveProps(nextProps){
    if (this.state.mappings !== nextProps.mappings) {
      this.setState({mappings: nextProps.mappings})
    }
  }

  componentDidMount() {
    this.props.actions.fetchDriftProperties()
    this.props.actions.fetchEloquaFields()
    this.props.actions.fetchEloquaMappings()
    this.getEloquaConfigValues()
  }

  patchDecorator = (strippedMappings, successCB) => {
    const payload = {mappings: strippedMappings}
    this.props.actions.patchEloquaMappings(payload, successCB)
  }

  getEloquaConfigValues = async () => {
    let eloquaConfig

    try {
      eloquaConfig = await getEloquaConfig()
    }
    catch(e) {
      console.warn(e)
    }

    this.setState({
      useCountryAcronyms: eloquaConfig.abbreviateCountryNames,
      useStateAcronyms: eloquaConfig.abbreviateStateNames
    })
  }

  onCountryUpdated = (newValue) => {
    const { notifications } = this.props
    const payload = {
      "abbreviateCountryNames" : newValue
    }

    try {
      patchEloquaConfig(payload)
      notifications.success(getSuccessMessage(integrationName))
    } catch(e) {
      console.warn(e)
    }
  }

  onStateUpdated = (newValue) => {
    const { notifications } = this.props
    const payload = {
      "abbreviateStateNames" : newValue
    }

    try {
      patchEloquaConfig(payload)
      notifications.success(getSuccessMessage(integrationName))
    } catch(e) {
      console.warn(e)
    }
  }

  render() {
    const { patchLoading, driftProperties, eloquaFields, actions, notifications } = this.props
    const { mappings, useCountryAcronyms, useStateAcronyms, specialFields } = this.state
    return (
      <div className="eloqua-mapping common-integration-page-layout">
        <IntegrationBreadcrumb
          backLinkText="Eloqua Integration"
          backLinkUrl={`/settings/setup/eloqua`}
        />
        <header>
          <h2 className="integration-header">Mapped Eloqua Contact Attributes</h2>
          <p> Map which fields you want to add to new Eloqua Leads. These Drift attributes will be added to new Eloqua Leads when they’re created. 
            <a href={HELP_DOC_URL}> Learn More</a>
          </p>
        </header>
        <AttributeMapper
          integrationName="Eloqua"
          mappings={mappings}
          driftAttributes={specialFields.concat(driftProperties)}
          integrationAttributes={eloquaFields}
          mappingModel={EloquaMapping}
          patchMappings={this.patchDecorator}
          patchLoading={patchLoading}
          allowAttributeDefaults={true} />
        <div className="eloqua-toggle-row">
          <Input
            className="eloqua-default-checkbox"
            type="checkbox"
            checked={useCountryAcronyms}
            onChange={this.onCountryUpdated}
          />
          <h1 className="eloqua-toggle-text">
            Send abbreviated country names to Eloqua (i.e. US instead of United States)
          </h1>
        </div>
        <div className="eloqua-toggle-row">
          <Input
            className="eloqua-default-checkbox"
            type="checkbox"
            checked={useStateAcronyms}
            onChange={this.onStateUpdated}
          />
          <h1 className="eloqua-toggle-text">
            Send abbreviated state names to Eloqua (i.e. NY instead of New York)
          </h1>
        </div>
      </div>
    )
  }
}

EloquaAttributeMapping.defaultProps = {
  allowAttributeDefaults: false
}

function mapStateToProps(state) {
  return {
    driftProperties: filteredProperties(state),
    mappings: getMappings(state),
    eloquaFields: getFields(state),
    patchError: didPatchErr(state),
    patchLoading: isPatchLoading(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchDriftProperties: fetchAttributes,
      fetchEloquaMappings,
      fetchEloquaFields,
      patchEloquaMappings
    }, dispatch)
  }
}

export default withNotifications(connect(mapStateToProps, mapDispatchToProps)(EloquaAttributeMapping))



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/EloquaAttributeMapping/index.js